/* globals global */
import Backbone from 'backbone';
import { render } from 'react-dom';

global.EasyPost = global.EasyPost || {};

export default Backbone.View.extend({
  template(context = {}) {
    if (!this.compiledTemplate) {
      throw new Error('No View.compiledTemplate defined');
    }

    return this.compiledTemplate(context);
  },

  context() {
    return {};
  },

  beforeRender() {},
  afterRender() {},
  onDomRefresh() {},
  onDomRefreshBase() {
    // run onDomRefresh for main view
    this.onDomRefresh();

    // run it for subviews
    this.ensureSubviews();
    Object.keys(this._subviews).forEach(name => this._subviews[name].instance.onDomRefresh());
  },

  render() {
    this.beforeRender();

    this.$el.html(this.template(this.context()));
    this.renderReactComponents();
    this.renderSubviews();
    this.afterRender();
    return this;
  },

  ensureSubviews() {
    if (!this._subviews) { this._subviews = {}; }
  },

  ensureReactComponents() {
    if (!this._reactComponents) { this._reactComponents = []; }
  },

  addSubview(name, selector, instance) {
    this.ensureSubviews();

    if (this.getSubview(name)) {
      this.removeSubview(name);
    }
    this._subviews[name] = { selector, instance };
  },

  addReactComponent(selector, instance) {
    this.ensureReactComponents();
    this._reactComponents.push({ instance, selector });
    return instance;
  },

  getSubview(name) {
    this.ensureSubviews();
    const subview = this._subviews[name];
    return subview ? subview.instance : undefined;
  },

  renderSubviews() {
    this.ensureSubviews();
    Object.keys(this._subviews).forEach(name => {
      const structure = this._subviews[name];
      structure.instance.setElement(this.$(structure.selector));
      structure.instance.render();
    });
  },

  renderReactComponents() {
    this.ensureReactComponents();

    this._reactComponents.forEach(({ instance, selector }) => {
      const el = this.$el.find(selector).get(0);
      render(instance, el);
    });
  },

  removeSubviews() {
    this.ensureSubviews();
    Object.keys(this._subviews).forEach(name => this.removeSubview(name));
  },

  removeSubview(name) {
    const subview = this.getSubview(name);
    if (subview) {
      subview.removeSubviews();
      subview.remove();
      subview.unbind();
      delete this._subviews[name];
    }
  },
});



// WEBPACK FOOTER //
// ./app/views/base.js